import { createRouter, createWebHashHistory } from 'vue-router';
import LoginPage from '@/pages/LoginPage.vue';
import DataDisplayPage from '@/pages/DataDisplayPage.vue';
import AdminPage from '@/pages/AdminPage.vue';
import PhoneVerify from '@/pages/PhoneVerify.vue';
import AnchorAdmin from '@/pages/AnchorAdmin.vue';
import AnchorGift from '@/pages/AnchorGift.vue';
import DashboardPage from '@/pages/DashboardPage.vue';
import PrayPage from '@/pages/PrayPage.vue';
import WorldPage from '@/pages/WorldPage.vue';
import DB from '@/pages/DBPage.vue';
import login from '@/pages/Login.vue';
import World from '@/pages/world.vue';
import Activity from '@/pages/ActivityManage.vue';
import NewServerReservation from '@/pages/NewServerReservation.vue';
import NoticeManage from '@/pages/NoticeManage.vue';
import AvatarStat from '@/pages/AvatarStat.vue';

const routes = [
  { path: '/', redirect: '/login' },
 { path: '/login', component: LoginPage },
  //{ path: '/', redirect: '/Dashboard' },
  //{ path: '/Dashboard', component: DashboardPage },
  {
    path: '/AvatarStat',
    component: AvatarStat,
    meta: { requiresAuth: true }
  },
  {
    path: '/world',
    component: WorldPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/Activity',
    component: Activity,
    meta: { requiresAuth: true }
  },
  {
    path: '/NewServerReservation',
    component: NewServerReservation,
    meta: { requiresAuth: true }
  },
   {
    path: '/NoticeManage',
    component: NoticeManage,
    meta: { requiresAuth: true }
  },
  {
    path: '/data',
    component: DataDisplayPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/Admin',
    component: AdminPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/PrayPage',
    component: PrayPage,
    meta: { requiresAuth: true }
  },

  {
    path: '/Dashboard',
    component: DashboardPage,
    children: [
      {
        path: '/AvatarStat',
        name: 'AvatarStat',
        component: AvatarStat
      },
      {
        path: '/Admin',
        name: 'Recharge',
        component: AdminPage
      },
      {
        path: '/AdminAnchor',
        name: 'Anchor',
        component: AnchorAdmin
      },
      {
        path: '/AnchorGift',
        name: 'AnchorGift',
        component: AnchorGift
      },
      {
        path: '/adminuser',
        name: 'AdminUser',
        component: () => import('@/pages/AdminUser.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/Activity',
        name: 'Activity',
        component: Activity
      },
      {
        path: '/NewServerReservation',
        name: 'NewServerReservation',
        component: NewServerReservation
      },
      {
        path: '/NoticeManage',
        name: 'NoticeManage',
        component: NoticeManage
      },
      {
        path: '/PrayPage',
        name: 'Pray',
        component: PrayPage
      },
      {
        path: '/ServerStatus',
        name: 'ServerStatus',
        component: () => import('@/pages/ServerStatus.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/wuxueSet',
        name: 'WuxueSet',
        component: () => import('@/pages/WuxueSet.vue')
      }

    ]
  },

  {
    path: '/AdminAnchor',
    component: AnchorAdmin,
    meta: { requiresAuth: true }
  },

  {
    path: '/phone-verify',
    name: 'PhoneVerify',
    component: PhoneVerify
  },
  { path: '/:pathMatch(.*)*', redirect: '/login' }
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});


// // router.beforeEach((to, from, next) => {
// //   next()
// // })

// ==========关键！全局前置守卫，你代码大概率缺少这一段==========
router.beforeEach((to, from, next) => {
  // 判断路由是否需要鉴权
  if (to.meta.requiresAuth) {
    // 从sessionStorage / sessionStorage取出你的token
    const token = sessionStorage.getItem('token')
    if (token) {
      // 有token放行
      next()
    } else {
      // 没有token跳转到登录页，带上原本要访问的地址，登录后可以回跳
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  } else {
    // 不需要登录的页面直接放行
    next()
  }
})

export default router;